import { ComponentsOverrides, Theme } from '@mui/material';

export const chipTheme: { styleOverrides: ComponentsOverrides<Theme>['MuiChip'] } = {
    styleOverrides: {
        root: ({ ownerState, theme }) => ({
            pointerEvents: 'none',
            fontSize: 12,
            fontWeight: 500,
            lineHeight: '14px',
            height: 'auto',

            borderRadius: theme.shape.borderRadius,
            backgroundColor: ownerState.color && theme.palette[ownerState.color]?.light,
            color: ownerState.color && theme.palette[ownerState.color]?.main,

            '& .MuiChip-label': {
                padding: theme.spacing(0.5),
            },
        }),
    },
};
